import { useEffect, useRef, useState } from "react";
import { InterfaceStep } from "../../types/formRVEO";

/**
 * Hook para manejar la navegación entre pasos del formulario
 */
export const useFormNavigation = (stepsFormData: any[]) => {
  const containerFormRef = useRef<any>(null);

  const [stepsForm, setStepsForm] = useState<InterfaceStep[]>([
    { id: 1, title: "Datos Personales", active: true },
    { id: 2, title: "Datos Financieros", active: false },
    { id: 3, title: "Beneficiarios", active: false },
    { id: 4, title: "Modalidades", active: false },
  ]);

  const [activeStep, setActiveStep] = useState<InterfaceStep>({
    id: 1,
    title: "Datos Personales",
    active: true,
  });

  useEffect(() => {
    if (stepsFormData && stepsFormData.length > 0) {
      setStepsForm(stepsFormData);
    }
  }, [stepsFormData]);

  const showTitleActive = (stepActive: number) =>
    stepsForm[stepsForm.findIndex((value) => value.id === stepActive)].title;

  const nextActiveStep = (stepActive: any) => {
    if (activeStep.id === stepsForm.length) return;

    const newActive = stepsForm.map((value: any) =>
      value.id === stepActive + 1
        ? { ...value, active: true }
        : { ...value, active: false }
    );
    if (containerFormRef.current) {
      containerFormRef.current.scrollTo(0, 0);
    }
    setStepsForm(newActive);
    const activeid = newActive.find((value) => value.active);
    setActiveStep(activeid);
  };

  const prevActiveStep = (stepActive: any) => {
    if (activeStep.id === 1) return;
    if (containerFormRef.current) {
      containerFormRef.current.scrollTo(0, 0);
    }
    const newActive = stepsForm.map((value: any) =>
      value.id === stepActive - 1
        ? { ...value, active: true }
        : { ...value, active: false }
    );
    setStepsForm(newActive);
    const activeid = newActive.find((value) => value.active);
    setActiveStep(activeid);
  };

  return {
    containerFormRef,
    stepsForm,
    setStepsForm,
    activeStep,
    setActiveStep,
    showTitleActive,
    nextActiveStep,
    prevActiveStep,
  };
};
